import { useEffect } from "react";

import { unlockNotificationAudio } from "@/lib/notificationSound";

/**
 * Browsers keep an AudioContext suspended until the first user gesture. Resume
 * it on the earliest pointer/keyboard interaction so the first notification
 * ping can play without waiting for the user to touch the preferences preview.
 */
export function useNotificationAudioUnlock(): void {
  useEffect(() => {
    const unlock = () => {
      unlockNotificationAudio();
      document.removeEventListener("pointerdown", unlock);
      document.removeEventListener("keydown", unlock);
    };
    document.addEventListener("pointerdown", unlock, { once: true });
    document.addEventListener("keydown", unlock, { once: true });
    return () => {
      document.removeEventListener("pointerdown", unlock);
      document.removeEventListener("keydown", unlock);
    };
  }, []);
}
